export enum UserType {
  PATIENT = 'patient',
  PHARMACY = 'pharmacy',
  PHARMACIST = 'pharmacist',
  ADMIN = 'admin',
  HEALTH_PROFESSIONAL = 'healthProfessional'
}
